import { Typography } from '@material-ui/core'
import axios from 'axios'
import { SubmitHandler, useForm } from 'react-hook-form'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { useAuth } from '@/hooks/use-auth'
import { getUser } from '@/services/get-user'

import { useStyles } from './styles'

interface FormData {
  currentPassword: string
}

interface CheckPasswordProps {
  handleClose: () => void
  checkPasswordAsTrue: () => void
}

export default function CheckPassword({
  handleClose,
  checkPasswordAsTrue,
}: CheckPasswordProps) {
  const classes = useStyles()
  const { user } = useAuth()
  const {
    handleSubmit,
    register,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      currentPassword: '',
    },
  })

  function setErrorByMessage(message: string) {
    setError(
      'currentPassword',
      {
        message,
      },
      { shouldFocus: true },
    )
  }

  const onSubmitCheckPasswordForm: SubmitHandler<FormData> = async (data) => {
    try {
      await getUser({ email: user.email, password: data.currentPassword })

      checkPasswordAsTrue()
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 403)
        return setErrorByMessage('Senha incorreta')

      setErrorByMessage('Erro ao verificar senha')
    }
  }

  return (
    <form
      className={classes.root}
      onSubmit={handleSubmit(onSubmitCheckPasswordForm)}
    >
      <div>
        <Typography>Para continuar, insira sua senha atual:</Typography>

        <InputText
          id='password-input'
          label='Senha atual'
          type='password'
          className={classes.input}
          error={Boolean(errors.currentPassword)}
          helperText={errors.currentPassword?.message}
          {...register('currentPassword', {
            required: 'A senha é obrigatório',
          })}
        />
      </div>
      <div className={classes.buttons}>
        <Button onClick={handleClose} outlined>
          Cancelar
        </Button>
        <Button
          disabled={Boolean(errors.currentPassword)}
          loading={isSubmitting}
          type='submit'
        >
          Continuar
        </Button>
      </div>
    </form>
  )
}
